import React from "react";
import { createRoot } from "react-dom/client";
import StackWarsPage from "../games/stack-wars/GamePage.js";
import TicTacToePage from "../games/tic-tac-toe/GamePage.js";
import MemoryMatchPage from "../games/memory-match/GamePage.js";
import GameRoutePage from "./GameRoutePage.js";
import LogoPreviewPage from "./LogoPreviewPage.js";
import LadooPage from "../games/ladoo/GamePage.js";
import CheckersPage from "../games/checkers/GamePage.js";
import HickroPage from "../games/hickro/GamePage.js";
import ParaTrooperPage from "../games/paratrooper/GamePage.js";
import TankWarsPage from "../games/tank-wars/GamePage.js";
import CarromPage from "../games/carrom/GamePage.js";
import PoolPage from "../games/pool/GamePage.js";
import BlockByBlockPage from "../games/block-by-block/GamePage.js";
import DodgeballPage from "../games/dodgeball/GamePage.js";
import AirHockeyPage from "../games/air-hockey/GamePage.js";
import SnakePage from "../games/snake/GamePage.js";
import ChessPage from "../games/chess/GamePage.js";
import HangmanPage from "../games/hangman/GamePage.js";
import MisterGamesPage from "./MisterGamesPage.js";
import HomepageMockups from "./HomepageMockups.js";
import "./site.css";
import "../games/ladoo/styles.css";
import "../games/stack-wars/styles.css";
import "../games/tic-tac-toe/styles.css";
import "../games/memory-match/styles.css";
import "../games/checkers/styles.css";
import "../games/hickro/styles.css";
import "../games/paratrooper/styles.css";
import "../games/tank-wars/styles.css";
import "../games/carrom/styles.css";
import "../games/pool/styles.css";
import "../games/block-by-block/styles.css";
import "../games/dodgeball/styles.css";
import "../games/air-hockey/styles.css";
import "../games/snake/styles.css";
import "../games/chess/styles.css";
import "../games/hangman/styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

function AppRouter() {
  const path = window.location.pathname.replace(/\/$/, "") || "/";

  if (path === "/stack-wars") {
    return <GameRoutePage title="Stack Wars" description="Drop, connect, and outsmart your rival in local play." GameComponent={StackWarsPage} />;
  }

  if (path === "/tic-tac-toe") {
    return <GameRoutePage title="Tic-Tac-Toe" description="The classic 3-in-a-row duel. Play solo or against a friend." GameComponent={TicTacToePage} />;
  }

  if (path === "/memory-match") {
    return <GameRoutePage title="Memory Match" description="Flip cards, find pairs, beat your best time." GameComponent={MemoryMatchPage} />;
  }

  if (path === "/logo-preview") {
    return <LogoPreviewPage />;
  }

  if (path === "/mockups") {
    return <HomepageMockups />;
  }

  if (path === "/ladoo") {
    return <GameRoutePage title="Ladoo" description="Roll the dice, race your tokens, and send opponents back to base!" GameComponent={LadooPage} />;
  }

  if (path === "/checkers") {
    return <GameRoutePage title="Checkers" description="Jump, capture, and crown your way to victory in this timeless board game." GameComponent={CheckersPage} />;
  }

  if (path === "/hickro") {
    return <GameRoutePage title="Hickro" description="Match cards by color or number — wild cards and action cards turn the tide!" GameComponent={HickroPage} />;
  }

  if (path === "/paratrooper") {
    return <GameRoutePage title="ParaTrooper" description="Blast paratroopers out of the sky before they reach the ground!" GameComponent={ParaTrooperPage} />;
  }

  if (path === "/tank-wars") {
    return <GameRoutePage title="Tank Wars" description="Aim, adjust for wind, and blow up the enemy tank with physics-powered shots!" GameComponent={TankWarsPage} />;
  }

  if (path === "/carrom") {
    return <GameRoutePage title="Carrom" description="Flick your striker and sink discs into pockets in this classic board game!" GameComponent={CarromPage} />;
  }

  if (path === "/pool") {
    return <GameRoutePage title="Pool" description="Rack 'em up, aim your cue, and sink the 8-ball to win!" GameComponent={PoolPage} />;
  }

  if (path === "/block-by-block") {
    return <GameRoutePage title="Block By Block" description="Stack falling blocks, clear lines, and chase the high score!" GameComponent={BlockByBlockPage} />;
  }

  if (path === "/dodgeball") {
    return <GameRoutePage title="Dodgeball" description="Aim, shoot, and dodge bouncing balls in this 2-player duel!" GameComponent={DodgeballPage} />;
  }

  if (path === "/air-hockey") {
    return <GameRoutePage title="Air Hockey" description="Paddle, deflect, and score! First to 7 wins!" GameComponent={AirHockeyPage} />;
  }

  if (path === "/snake") {
    return <GameRoutePage title="Snake" description="Eat, grow, survive. Classic arcade snake with neon visuals." GameComponent={SnakePage} />;
  }

  if (path === "/chess") {
    return <GameRoutePage title="Chess" description="Outsmart your opponent in the classic strategy board game." GameComponent={ChessPage} />;
  }

  if (path === "/hangman") {
    return <GameRoutePage title="Hangman" description="Guess the word before the hangman is complete!" GameComponent={HangmanPage} />;
  }

  return <MisterGamesPage />;
}

createRoot(root).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);